// GENERATED FILE. Do not edit by hand. Produced by `bun run codegen`.

import Ajv from "ajv";
import addFormats from "ajv-formats";
import call from "../../sdk-helpers/call";
import { logError } from "../../sdk-helpers/shouldLog";

export type typeOauthGoogleVerifyBody = {
  idToken: string;
};

export type typeOauthGoogleVerifyOutput200 = {
  error?: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data?: null | {
    accessToken: string;
    refreshToken: string;
    expiresInSeconds: number;
    user: { userId: string; email?: string | null; isSuperAdmin: boolean };
  };
};

export type typeOauthGoogleVerifyOutput400 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeOauthGoogleVerifyOutput401 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeOauthGoogleVerifyOutput500 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export const schemaOauthGoogleVerifyBody = {
  type: "object",
  properties: { idToken: { type: "string", maxLength: 3000, minLength: 1 } },
  required: ["idToken"],
} as const;

export type SdkOptions = {
  headers?: Record<string, string>;
  apiHost?: string;
  prefix?: string;
};

let compiledValidator: ReturnType<Ajv["compile"]> | null = null;

export default function createOauthGoogleVerify(options: SdkOptions) {
  if (!compiledValidator) {
    const ajv = new Ajv({ strict: false });
    addFormats(ajv);
    compiledValidator = ajv.compile(schemaOauthGoogleVerifyBody);
  }

  return async function postOauthGoogleVerify(
    payload: typeOauthGoogleVerifyBody,
  ): Promise<typeOauthGoogleVerifyOutput200 | typeOauthGoogleVerifyOutput400> {
    const isValid = compiledValidator!(payload);
    if (!isValid) {
      logError(
        `Payload validation inside SDK method "postOauthGoogleVerify" failed before calling the network. #06d88f2da942`,
        compiledValidator!.errors,
      );
      return {
        error: {
          code: "VALIDATION_ERROR",
          message: "Request payload failed schema validation.",
          details: { errors: compiledValidator!.errors, ref: "#06d88f2da942" },
        },
        data: null,
      } as typeOauthGoogleVerifyOutput400;
    }

    const prefix = options?.prefix ?? "";
    return (await call({
      payload,
      endpoint: `${prefix}/oauth/google-verify`,
      httpMethod: "POST",
      options,
    })) as typeOauthGoogleVerifyOutput200 | typeOauthGoogleVerifyOutput400;
  };
}
